var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.073 8.67301C16.8986 8.49824 16.6619 8.40002 16.415 8.40002C16.1681 8.40002 15.9314 8.49824 15.757 8.67301L11.473 12.957C11.109 13.321 11.109 13.909 11.473 14.273L15.757 18.557C16.121 18.921 16.709 18.921 17.073 18.557C17.437 18.193 17.437 17.605 17.073 17.241L13.4517 13.6103L17.073 9.98901C17.437 9.62501 17.4277 9.02768 17.073 8.67301Z",
    fill: "current",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.fed9c4fbcbca2a86f0ac425bdfc0eb67.svg";
export { ForwardRef as ReactComponent };